import React from "react";
import Svg, { Path } from "react-native-svg";

const Cart = (props) => {
  const { color = "#fff", height = 14, width = 14 } = props;

  return (
    <Svg width={width} height={height} fill="none" {...props}>
      <Path
        d="M4.198 11.2c-.77 0-1.392.63-1.392 1.4 0 .77.623 1.4 1.392 1.4.77 0 1.4-.63 1.4-1.4 0-.77-.63-1.4-1.4-1.4zM0 .7c0 .385.315.7.7.7h.7l2.519 5.313-.945 1.708c-.51.938.16 2.079 1.224 2.079h7.698c.384 0 .7-.315.7-.7 0-.385-.316-.7-.7-.7H4.198l.77-1.4h5.213c.525 0 .987-.287 1.225-.721l2.505-4.543a.697.697 0 00-.609-1.036H2.946L2.477.399A.695.695 0 001.847 0H.7C.315 0 0 .315 0 .7zm11.196 10.5c-.77 0-1.393.63-1.393 1.4 0 .77.623 1.4 1.393 1.4s1.4-.63 1.4-1.4c0-.77-.63-1.4-1.4-1.4z"
        fill={color}
      />
    </Svg>
  );
};

export default Cart;
